import get from "lodash.get";
import { Control, FieldPath, FieldValues, RegisterOptions, useFormState } from "react-hook-form";

import SinglePickerFormField from "src/components/Pickers/SinglePickerFormField.tsx";
import { useT } from "src/internationalization";
import { useConfList } from "src/providers/ConfListsProvider";
import { ConfListElement } from "src/types/confList";

export type FraudTypeSinglePickerFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
  label: string;
  type?: string;
  helperText?: string;
  placeholder?: string;
  control: Control<TFieldValues>;
  ["aria-label"]?: string;
  rules?: Omit<
    RegisterOptions<TFieldValues, TName>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  name: TName;
};

export function FraudTypeSinglePickerFormField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  rules,
  helperText,
  control,
  label,
}: FraudTypeSinglePickerFormFieldProps<TFieldValues, TName>) {
  const { errors } = useFormState({ control });
  const error = get(errors, name);

  const fraudTypesList = useConfList("FraudType");

  const t = useT();

  return (
    <SinglePickerFormField<ConfListElement, TFieldValues, TName>
      name={name}
      rules={rules}
      itemToString={(item) => {
        return item?.name ?? "";
      }}
      items={fraudTypesList?.elements ?? []}
      loading={false}
      error={undefined}
      invalidText={(error?.message as string) ?? t("component.picker.fraud.type.invalid")}
      titleText={label}
      helperText={helperText}
    />
  );
}
